class AddonSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupTabs();
    this.setupDate();
    this.setupAddToCart();
    setTimeout(function() {
      this.openTab(this.tabs[0], false, false);
    }.bind(this), 300);
  }

  setupTabs() {
    this.tabs = this.querySelectorAll('.addon-section--tab');

    for(const tab of this.tabs) {
      const tabButton = tab.querySelector('.addon-section__tab--accordion-button');
      const tabContent = tab.querySelector('.addon-section__tab--content');
      const tabInner = tab.querySelector('.addon-section__tab--inner');

      new ResizeObserver(function() {
        tabContent.style.setProperty('--inner-height', `${tabInner.getBoundingClientRect().height + 10}px`);
      }).observe(tabInner);

      tabContent.style.setProperty('--inner-height', `${tabInner.getBoundingClientRect().height + 10}px`);

      this.setupTabProducts(tab);

      tabButton.addEventListener('click', async function() {
        if(tab.classList.contains('open')) {
          tab.classList.remove('open');
        } else {
          const timeout = await this.closeOpenTab();
          this.openTab(tab, timeout, true);
        }
      }.bind(this));
    }
  }

  recalculateTabHeight(tab, height) {
    const tabContent = tab.querySelector('.addon-section__tab--content');

    tabContent.style.setProperty('--inner-height', `${height}px`);
  }

  async closeOpenTab() {
    for(const tab of this.tabs) {
      if(tab.classList.contains('open')) {
        tab.classList.remove('open');
        return true;
      }
    }
    return false;
  }

  openTab(tab, timeout, scroll) {
    if(timeout) {
      setTimeout(function() {
        const tabContent = tab.querySelector('.addon-section__tab--content');
        const tabInner = tab.querySelector('.addon-section__tab--inner');
        tabContent.style.setProperty('--inner-height', `${tabInner.getBoundingClientRect().height + 10}px`);
        tab.classList.add('open');
        if(scroll) {
          setTimeout(function() {
            tab.scrollIntoView({behavior: "smooth"});
          }, 500);
        }
        //document.querySelector('.addon-section--anchor').scrollTo({top: tab.getBoundingClientRect().top, left: 0, behavior: "smooth"});
      }, 500);
    } else {
      const tabContent = tab.querySelector('.addon-section__tab--content');
      const tabInner = tab.querySelector('.addon-section__tab--inner');
      tabContent.style.setProperty('--inner-height', `${tabInner.getBoundingClientRect().height + 10}px`);
      tab.classList.add('open');
      if(scroll) {
        setTimeout(function() {
          tab.scrollIntoView({behavior: "smooth"});
        }, 500);
      }
      //document.querySelector('.addon-section--anchor').scrollTo({top: tab.getBoundingClientRect().top, left: 0, behavior: "smooth"});
    }
  }

  nextTab(tab) {
    for(let i = 0; i < this.tabs.length; i++) {
      if(this.tabs[i] == tab && i+1 < this.tabs.length) {
        return this.tabs[i+1];
      }
    }
  }

  setupTabProducts(tab) {
    const productContainer = tab.querySelector('.addon-section__tab--products');
    if(productContainer) {
      const products = productContainer.querySelectorAll('.addon-section__tab--product-card');
      const nextButton = tab.querySelector('.add-section__tab--textarea-button');
      const showMoreButton = tab.querySelector('.addon-section__tab--product-show-more');

      let lastProductToShow = 5;
      if(products.length < 6) {
        lastProductToShow = products.length - 1;
        showMoreButton.classList.add('hide');
      }

      if(showMoreButton) {
        const tabContent = tab.querySelector('.addon-section__tab--inner');
  
        //productContainer.style.setProperty('--full-height', `${productContainer.getBoundingClientRect().height + 5}px`);
        productContainer.style.setProperty('--less-height', `${products[lastProductToShow].getBoundingClientRect().bottom - productContainer.getBoundingClientRect().top }px`);
        
        if(productContainer.getBoundingClientRect().height == products[lastProductToShow].getBoundingClientRect().bottom - productContainer.getBoundingClientRect().top ) {
          showMoreButton.classList.add('hide');
        } else {
          const tabContentFull = tabContent.getBoundingClientRect().height;
          //const tabContentLess = tabContentFull - (productContainer.getBoundingClientRect().height - products[lastProductToShow].getBoundingClientRect().bottom - productContainer.getBoundingClientRect().top ) + 10;
        
          productContainer.classList.add('show-less');
          //this.recalculateTabHeight(tab, tabContentLess);

          let clickCounter = 0;
          const productsToShow = [];
          if(window.innerWidth > 1040) {
            
          }
          
          showMoreButton.addEventListener('click', function() {
            let tabContentFull = tabContent.getBoundingClientRect().height;
            if(clickCounter == 0) {
              if(products.length > 29) {
                tabContentFull = products[29].getBoundingClientRect().bottom - productContainer.getBoundingClientRect().top;
                productContainer.style.setProperty('--less-height', `${products[29].getBoundingClientRect().bottom - productContainer.getBoundingClientRect().top }px`);
              } else {
                tabContentFull = tabContent.getBoundingClientRect().height;
                productContainer.classList.remove('show-less');
                showMoreButton.classList.add('hide');
              }
            } else if(clickCounter == 1) {
              if(products.length > 59) {
                tabContentFull = products[59].getBoundingClientRect().bottom - productContainer.getBoundingClientRect().top;
                productContainer.style.setProperty('--less-height', `${products[59].getBoundingClientRect().bottom - productContainer.getBoundingClientRect().top }px`);
              } else {
                tabContentFull = tabContent.getBoundingClientRect().height;
                productContainer.classList.remove('show-less');
                showMoreButton.classList.add('hide');
              }
            } else {
              productContainer.classList.remove('show-less');
              showMoreButton.classList.add('hide');
            }
            this.recalculateTabHeight(tab, tabContentFull);
            
            
            /*productContainer.classList.remove('show-less');
            this.recalculateTabHeight(tab, tabContentFull);
            showMoreButton.classList.add('hide');*/
            clickCounter++;
          }.bind(this));
        }        
      }
      
      if(nextButton) {
        nextButton.addEventListener('click', async function() {
          const timeout = await this.closeOpenTab();
          this.openTab(this.nextTab(tab), timeout, true);
        }.bind(this));
      }
      
      for(const product of products) {
        product.addEventListener('click', async function() {
          if(productContainer.querySelector('.addon-section__tab--product-card.selected')) {
            productContainer.querySelector('.addon-section__tab--product-card.selected').classList.remove('selected');
          }
          product.classList.add('selected');
          if(!nextButton || products[0] == product) {
            const timeout = await this.closeOpenTab();
            this.openTab(this.nextTab(tab), timeout, true);
          } else {
            nextButton.scrollIntoView({behavior: "smooth"});
          }
        }.bind(this));
      }
    }
  }

  setupDate() {
    /*const dateTab = this.tabs[this.tabs.length - 1];
    const drawerDateItems = dateTab.querySelectorAll('.cart-drawer__date--item:not(.cart-drawer__date--date-picker)');
    const drawerDateInput = dateTab.querySelector('rao-date-picker .rao-date-picker--asd');
  
    for(let i = 0; i < drawerDateItems.length; i++) {
      if(i == 0) {
        drawerDateInput.value = drawerDateItems[i].dataset.date;
      }
      drawerDateItems[i].addEventListener('click', function() {
        if(dateTab.querySelector('.cart-drawer__date--item.checked')) {
          dateTab.querySelector('.cart-drawer__date--item.checked').classList.remove('checked');
        }
        drawerDateItems[i].classList.add('checked');
        drawerDateInput.value = drawerDateItems[i].dataset.date;
        dateTab.querySelector('.cart-drawer__date--date-picker .cart-drawer__date--text span').innerText = "";
        if(dateTab.querySelector('.rao-date-picker--day-name.selected')) {
          dateTab.querySelector('.rao-date-picker--day-name.selected').classList.remove('selected');
        }
      });
    }*/
  }

  checkTabItems() {
    for(let i = 0; i < this.tabs.length - 1; i++) {
      const selectedItem = this.tabs[i].querySelector('.addon-section__tab--product-card.selected');
      if(!selectedItem) {
        return i;
      }
    }
    return -1;
  }

  getTabItems() {
    const items = [];
    for(let i = 0; i < this.tabs.length - 1; i++) {
      const selectedItem = this.tabs[i].querySelector('.addon-section__tab--product-card.selected');
      const id = selectedItem.querySelector('input') ? selectedItem.querySelector('input').value : null ;
      if(id) {
        const textarea = this.tabs[i].querySelector('textarea');
        if(textarea) {
          items.push({id: id, note: textarea.value})
        } else {
          items.push({id: id})
        }
      }
    }

    return items;
  }

  setupAddToCart() {
    const tab = this.tabs[this.tabs.length - 1];
    const button = tab.querySelector('buy-buttons button');
    button.addEventListener('click', async function(e) {
      if(!button.classList.contains('safe-to-add')) {
        e.preventDefault();
        const index = this.checkTabItems();
        if(index != -1) {
          // Item(s) not selected
          const timeout = await this.closeOpenTab();
          this.openTab(this.tabs[index], timeout, true);
        } else {
          const items = this.getTabItems();
          button.classList.add('safe-to-add')
          button.click();
        }
      }
    }.bind(this));
  }
}

customElements.define('addon-section', AddonSection);

window.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.rao-product-card');
  for(const productCard of productCards) {
    const quickBuy = productCard.querySelector('.product-card__quick-buy');

    if(quickBuy) {
      productCard.addEventListener('click', function(e) {
        if(quickBuy.contains(e.target)) {
          e.preventDefault();
          quickBuy.querySelector('form')._onSubmit(new SubmitEvent("submit", {submitter: quickBuy.querySelector('form')}));
        }
      });
    }
  }

  
  /* Product Page cheat */
  /*const addonContainer = document.querySelector('.product-info--extra-products');
  if(addonContainer) {
    if(window.innerWidth < 699) {
      addonContainer.style.setProperty('--width', `${window.innerWidth - 32}px`);
    }

    window.addEventListener('resize', function() {
      if(window.innerWidth < 699) {
        addonContainer.style.setProperty('--width', `${window.innerWidth - 32}px`);
      }
    });
  }*/
  
  /* Sticky add to cart filled balloons popup */
  /*if(document.querySelectorAll('.product-info__extra-products--item').length != 0) {
    const stickyButtons = document.querySelectorAll('.product-quick-buy--right-side button');
  
    for(const stickyButton of stickyButtons) {
      stickyButton.addEventListener('click', function(e) {
        if(document.querySelectorAll('.product-info__extra-products--item.checked').length == 0) {
          const form = document.querySelector(`form#${stickyButton.getAttribute('form')}`);
          form.classList.add('quick-buy--met-helium');
        }
      });
    }
  }

  const addToCartButtons = document.querySelectorAll('.product-info__block-item[data-block-type="buy-buttons"] button');

  for(const addToCartButton of addToCartButtons) {
    addToCartButton.addEventListener('click', function(e) {
      const form = addToCartButton.closest('form');
      form.classList.remove('quick-buy--met-helium');
    });
  }*/
  
  /* Filled balloons popup */
  const balloonButton = document.querySelector('.product--filled-balloon-button');
  const balloonPopup = document.querySelector('.product__filled-balloon-button--popup');

  if(balloonButton && balloonPopup) {
    const balloonContainer = balloonPopup.querySelector('.product__filled-balloon-button--popup-container');
    const balloonClose = balloonContainer.querySelector('svg');
    
    balloonButton.addEventListener('click', function() {
      balloonPopup.classList.add('open');
      document.documentElement.classList.add('lock');
    });

    balloonPopup.addEventListener('click', function(e) {
      if(!balloonContainer.contains(e.target)) {
        balloonPopup.classList.remove('open');
        document.documentElement.classList.remove('lock');
      }
    });

    balloonClose.addEventListener('click', function(e) {
      balloonPopup.classList.remove('open');
      document.documentElement.classList.remove('lock');
    });
  }
});

/* Infinite Collection */
class RAOCollection extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    if(typeof this.dataset.infiniteLoading != "undefined") {
      this.setupGlobals();
      this.triggers();
    }
  }
  
  disconnectedCallback() {
    window.removeEventListener('scroll', this.bs);
  }

  async asd() {
    if(this.prevPos == null) {
      this.prevPos = window.scrollY;
    }
    
    if(window.scrollY > this.prevPos) {
      // scrolling down
      if(!this.nextPagesLoaded) {
        if(this.getBoundingClientRect().bottom < window.innerHeight && !this.loading) {
          this.loading = true;
          this.bottomLoad.classList.add('show');
          await this.getNextPage();
          this.loading = false;
          setTimeout(function(){}, 1000);
          this.bottomLoad.classList.remove('show');
        }
      }
      
      this.prevPos = window.scrollY;
      if(this.lastCards[this.currentPage - 1] && !this.loading) {
        const card = this.lastCards[this.currentPage - 1];
        if(card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 < window.innerHeight && card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 > 0) {
          if(this.currentPage + 1 <= this.lastCards.length) {
            this.currentPage += 1;
            this.searchParams.set("page", this.currentPage);
            this.searchParams.delete("section_id");
            window.history.replaceState({}, "", this.url);
          }
        }
      }
    }
    if(window.scrollY < this.prevPos) {
      // scrolling up
      if(!this.prevPagesLoaded && this.currentPage > 1) {
        if(this.getBoundingClientRect().top > -62 && !this.loading) {
          this.loading = true;
          this.topLoad.classList.add('show');
          await this.getPrevPage();
          this.loading = false;
          setTimeout(function(){}, 1000);
          this.topLoad.classList.remove('show');
        }
      }

      this.prevPos = window.scrollY;
      if(this.currentPage > 1 && !this.loading) {
        const card = this.lastCards[this.currentPage - 2];
        if(card) {
          if(card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 > window.innerHeight) {
            this.currentPage -= 1;
            this.searchParams.set("page", this.currentPage);
            this.searchParams.delete("section_id");
            window.history.replaceState({}, "", this.url);
          }
        }
      }
    }
  }

  triggers() {
    this.bs = this.asd.bind(this);
    this.prevPos = null;
    window.addEventListener('scroll', this.bs);
  }

  getLastCards() {
    console.log(this.lastCards);
  }

  setupGlobals() {
    this.sectionId = this.closest('section').id.replace('shopify-section-', '');
    this.productList = this.querySelector('product-list');

    this.topLoad = this.querySelector('.rao-collection--load-more-top');
    this.bottomLoad = this.querySelector('.rao-collection--load-more-bottom');
    
    this.url = new URL(window.location.href);
    this.searchParams = this.url.searchParams;
    this.currentPage = 1;                                                    // Page content what the user sees, changes based on scroll.
    if(this.searchParams.has("page")) {
      this.currentPage = parseInt(this.searchParams.get("page"));
    }

    this.lastCards = [];
    this.lastCards[this.currentPage - 1] = this.productList.children[this.productList.children.length - 1];

    this.prevPagesLoaded = false;
    if(this.currentPage == 1) {
      this.prevPagesLoaded = true;
    }
    this.nextPagesLoaded = false;
  }

  async getPrevPage() {
    const scrollPos = window.scrollY;
    this.searchParams.set("page", this.currentPage - 1);
    this.searchParams.set("section_id", this.sectionId);
    
    const htmlTemp = await (await fetch(this.url, {
      method: "GET",
      headers: {
        "Content-Type": "text/html"
      }
    })).text();

    const html = document.implementation.createHTMLDocument("asd");
    html.body.innerHTML = htmlTemp;

    const newProductCardsContainer = html.querySelector('product-list');
    
    let lastCard;
    for(let i = newProductCardsContainer.children.length - 1; i >= 0; i--) {
      this.productList.prepend(newProductCardsContainer.children[i].cloneNode(true));
    }

    this.lastCards[this.currentPage - 2] = this.productList.children[newProductCardsContainer.children.length - 1];
    this.lastCards[this.currentPage - 2].scrollIntoView();
    
    this.currentPage -= 1;
    this.searchParams.set("page", this.currentPage);

    this.searchParams.delete("section_id");
    window.history.replaceState({}, "", this.url);

    if(this.currentPage == 1) {
      this.prevPagesLoaded = true;
    }
  }

  async getNextPage() {
    this.searchParams.set("page", this.currentPage + 1);
    this.searchParams.set("section_id", this.sectionId);
    
    const htmlTemp = await (await fetch(this.url, {
      method: "GET",
      headers: {
        "Content-Type": "text/html"
      }
    })).text();

    const html = document.implementation.createHTMLDocument("asd");
    html.body.innerHTML = htmlTemp;


    const newProductCards = html.querySelectorAll('.rao-product-card');
    if(newProductCards.length == 0) {
      this.nextPagesLoaded = true;
    }

    if(newProductCards.length != 0) {
      for(const newCard of newProductCards) {
        this.productList.appendChild(newCard);
      }

      this.lastCards.push(newProductCards[newProductCards.length - 1]);
      this.currentPage += 1;
      this.searchParams.set("page", this.currentPage);

      this.searchParams.delete("section_id");
      window.history.replaceState({}, "", this.url);
    }
  }
}

customElements.define('rao-collection', RAOCollection);

/* Date Picker */
class RAODatePicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector('.rao-date-picker--container');
    this.blockTemp = this.container.querySelector('.rao-date-picker--block');
    this.blockTemp.remove();
    this.blacklistedDates = this.dataset.blacklistedDates.split(',');
    this.monthAmountShown = parseInt(this.dataset.monthAmountShown);
    this.monthNames = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
    this.monthLastDays = [31, 30, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    this.dayNames = ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];
    this.textDayNames = ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"];
    this.parentContainerElement = this.closest('.cart-drawer__date--items');

    this.createCalendar();
    this.setupEvents();

    if(this.parentContainerElement.querySelectorAll('.cart-drawer__date--item:not(.cart-drawer__date--date-picker)').length != 0) {
      for(const parentContainer of this.parentContainerElement.querySelectorAll('.cart-drawer__date--item:not(.cart-drawer__date--date-picker)')) {
        parentContainer.addEventListener('click', function() {
          if(this.parentContainerElement.querySelector('.cart-drawer__date--item.checked')) {
            this.parentContainerElement.querySelector('.cart-drawer__date--item.checked').classList.remove('checked');
          }
          parentContainer.classList.add('checked');
          this.parentContainerElement.querySelector('rao-date-picker input').value = parentContainer.dataset.date;
          this.parentContainerElement.querySelector('.cart-drawer__date--date-picker .cart-drawer__date--text span').innerText = "";
          if(parentContainer.querySelector('.rao-date-picker--day-name.selected')) {
            parentContainer.querySelector('.rao-date-picker--day-name.selected').classList.remove('selected');
          }
          localStorage.setItem('date', parentContainer.dataset.date);
        }.bind(this));
      }
    } else {
      //this.parentContainerElement.querySelector(`[data-date]:not(.no-hover)`).click();
    }

    if(localStorage.getItem("date")) {
      this.setDate(localStorage.getItem("date"));
    } else {
      this.parentContainerElement.querySelector(`[data-date]:not(.no-hover)`).click();
      this.parentContainerElement.querySelector('.cart-drawer__date--item').click();
      this.setDate(localStorage.getItem("date"));
    }

    window.addEventListener('date:change', function(e) {
      if(this.parentContainerElement.querySelector('.cart-drawer__date--item.checked')) {
        this.parentContainerElement.querySelector('.cart-drawer__date--item.checked').classList.remove('checked');
      }
      this.setDate(e.detail.date);
    }.bind(this));
  }

  setDate(date) {
    if(this.parentContainerElement.querySelector(`[data-date="${date}"]:not(.no-hover)`)) {
      this.parentContainerElement.querySelector(`[data-date="${date}"]:not(.no-hover)`).click();
      this.parentContainerElement.querySelector(`[data-date="${date}"]:not(.no-hover)`).closest('.cart-drawer__date--item').classList.add('checked');
      this.parentContainerElement.querySelector('rao-date-picker input').value = this.parentContainerElement.querySelector(`[data-date="${date}"]:not(.no-hover)`).dataset.date;
    } else {
      /*localStorage.removeItem("date")
      this.parentContainerElement.querySelector('.cart-drawer__date--item').click();*/
    }
  }

  setupEvents() {
    const parentContainer = this.closest('.cart-drawer__date--date-picker');
    const prevButton = this.querySelector('.rao-date-picker--previous');
    const nextButton = this.querySelector('.rao-date-picker--next');
    const inputPicker = this.querySelector('.rao-date-picker--input');
    //const inputText = inputPicker.querySelector('.rao-date-picker__input--content');
    const inputText = parentContainer.querySelector('.cart-drawer__date--text span');
    const dayItems = this.querySelectorAll('.rao-date-picker--day-name:not(.no-hover)');
    const input = this.querySelector('input');
    this.selectedDay = "";
    
    this.currentSlide = 0;

    prevButton.addEventListener('click', function() {
      if(this.currentSlide != 0) {
        this.currentSlide--;
        this.container.style.setProperty("--transform-amount", `-${this.currentSlide * 100}%`);
        if(this.currentSlide == 0) {
          prevButton.classList.add('disabled');
        }
        nextButton.classList.remove('disabled');
      }
    }.bind(this));

    nextButton.addEventListener('click', function() {
      if(this.currentSlide != this.container.querySelectorAll('.rao-date-picker--block').length - 1) {
        this.currentSlide++;
        this.container.style.setProperty("--transform-amount", `-${this.currentSlide * 100}%`);
        if(this.currentSlide == this.container.querySelectorAll('.rao-date-picker--block').length - 1) {
          nextButton.classList.add('disabled');
        }
        prevButton.classList.remove('disabled');
      }
    }.bind(this));

    parentContainer.addEventListener('click', function(e) {
      if(!this.contains(e.target)) {
        if(parentContainer.closest('.cart-drawer__top--date-picker')) {
          this.container.style.setProperty('--left-amount', `${parentContainer.closest('.cart-drawer__top--date-picker').getBoundingClientRect().left}px`);
          this.container.style.setProperty('--top-amount', `${parentContainer.closest('.cart-drawer__top--date-picker').getBoundingClientRect().bottom}px`);
        } else {
          this.container.style.setProperty('--top-amount', `${parentContainer.getBoundingClientRect().top - this.container.getBoundingClientRect().bottom}px`);
        }
        this.container.classList.toggle('open');
      }
    }.bind(this));

    window.addEventListener('click', function(e) {
      if(this.container.classList.contains('open')) {
        if(!parentContainer.contains(e.target)) {
          this.container.classList.remove('open');
        }
      }
    }.bind(this));

    for(const dayItem of dayItems) {
      dayItem.addEventListener('click', function() {
        if(this.selectedDay != "") {
          this.selectedDay.classList.remove('selected');
        }

        const textDateTemp = new Date(dayItem.dataset.date);
        
        dayItem.classList.add('selected');
        this.container.classList.remove('open');
        if(this.dataset.dateFormat) {
          inputText.innerText = `${textDateTemp.getDate().toString().padStart(2, "0")}-${(textDateTemp.getMonth() + 1).toString().padStart(2, "0")}-${textDateTemp.getFullYear()}`;
        } else {
          inputText.innerText = `: ${this.textDayNames[textDateTemp.getDay()]} ${textDateTemp.getDate()} ${this.monthNames[textDateTemp.getMonth()].toLowerCase()}`;
        }
        this.selectedDay = dayItem;
        input.value = dayItem.dataset.date;
        if(this.parentContainerElement.querySelector('.cart-drawer__date--item.checked')) {
          this.parentContainerElement.querySelector('.cart-drawer__date--item.checked').classList.remove('checked');
        }
        
        parentContainer.classList.add('checked');
        localStorage.setItem('date', dayItem.dataset.date);
      }.bind(this));
    }
  }

  createCalendar() {
    this.currentDate = new Date();
    this.firstAvailableDate = new Date();
    this.disabledDays = 0;
    this.validDayCounter = 0;
    this.firstAvailableDate.setHours(24);

    if(this.currentDate.getDay() == 5) {
      if(this.currentDate.getHours() >= 16) {
        this.firstAvailableDate.setHours(48);
      }
    } else if(this.currentDate.getDay() == 6) {
      this.firstAvailableDate.setHours(24);
    } else if(this.currentDate.getDay() == 0) {
      //this.firstAvailableDate.setHours(24);
    } /*else if(this.currentDate.getHours() >= 16) {
      this.firstAvailableDate.setHours(24);
    }*/

    this.firstAvailableDate = new Date(this.firstAvailableDate);
    let currentMonthIndex = this.currentDate.getMonth();
    let currentYear = this.currentDate.getFullYear();
    
    for(let i = 0; i < this.monthAmountShown; i++) {
      this.disabledDays = 0;
      const blockElement = this.blockTemp.cloneNode(true);
      const monthElement = blockElement.querySelector('.rao-date-picker--month');
      const daysContainer = blockElement.querySelector('.rao-date-picker--days');
      if(currentMonthIndex > 11) {
         currentMonthIndex = 0;
        currentYear++;
      }
      monthElement.innerText = this.monthNames[currentMonthIndex];

      this.parseDayNames(daysContainer);
      const showMonth = this.parseWeeks(daysContainer, 1, currentYear, currentMonthIndex);

      currentMonthIndex++;
      if(showMonth) {
        this.container.appendChild(blockElement);
      } else {
        this.monthAmountShown++;
      }
    }
  }

  parseDayNames(daysContainer) {
    const weekElement = document.createElement('div');
    weekElement.classList.add('rao-date-picker--week');
    
    for(let i = 0; i < 7; i++) {
      const dayElement = document.createElement('span');
      dayElement.classList.add('rao-date-picker--day-name');
      dayElement.classList.add('no-hover');

      dayElement.innerText = this.dayNames[i];
      weekElement.appendChild(dayElement);
    }

    daysContainer.appendChild(weekElement);
  }

  parseWeeks(daysContainer, startingDay, year, monthIndex) {
    let monthIndexTemp = monthIndex;
    let monthLastDay = 28;

    if(monthIndex != 1) {
      monthLastDay = this.monthLastDays[monthIndex];
    } else {
      if(new Date(`${year}-${monthIndex + 1}-29`).getMonth() == monthIndex) {
        monthLastDay = 29;
      } else {
        monthLastDay = 28;
      }
    }

    if(startingDay <= monthLastDay) {
      let date = new Date(`${year}-${(monthIndex + 1).toString().padStart(2, "0")}-${startingDay.toString().padStart(2, "0")}`);
      const weekElement = document.createElement('div');
      weekElement.classList.add('rao-date-picker--week');
      let counter = 0;

      for(let i = 0; i < 7; i++) {
        let disabledDay = false;
        if(parseInt(startingDay)+i > monthLastDay) {
          break;
        }
        
        const dayElement = document.createElement('span');
        dayElement.classList.add('rao-date-picker--day-name');

        let getDay = date.getDay();
        if(getDay == 0) {
          getDay = 7;
        }
        if(i + 1 == getDay) {
          /* Disable days */
          if(this.blacklistedDates.includes(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${(date.getDate()).toString().padStart(2, "0")}`)) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
            disabledDay = true;
          }

          if(date < this.firstAvailableDate) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
            disabledDay = true;
          }

          if(date.getDay() == 0) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
            disabledDay = true;
          }

          const blockedDaysAmount = this.dataset.blockedDaysAmount ? parseInt(this.dataset.blockedDaysAmount) : 3;

          if(!disabledDay && this.validDayCounter < blockedDaysAmount) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
            disabledDay = true;
            this.validDayCounter++;
          }

          if(disabledDay) {
            this.disabledDays++;
          }
             
          /* Increment date */
          dayElement.innerText = date.getDate();
          dayElement.dataset.date = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${(date.getDate()).toString().padStart(2, "0")}`;
          date.setDate(date.getDate() + 1);
          counter++;
        } else {
          dayElement.classList.add('no-hover');
        }

        weekElement.appendChild(dayElement);
      }

      daysContainer.appendChild(weekElement);
      if(parseInt(startingDay)+counter <= monthLastDay) {
        this.parseWeeks(daysContainer, parseInt(startingDay)+counter, date.getFullYear(), date.getMonth());
      }
    }

    if(this.disabledDays == monthLastDay) {
      return false;
    }
    
    return true;
  }
}

customElements.define('rao-date-picker', RAODatePicker);

class TooltipInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tooltipButton = this.querySelector('svg');
    const tooltipText = this.querySelector('.product-info__extra-products--tooltip-info');
    const headerHeight = document.querySelector('header').getBoundingClientRect().height + document.querySelector('.shopify-section--announcement-bar').getBoundingClientRect().height;

    this.positionContent(tooltipText, headerHeight);
    
    tooltipButton.addEventListener('click', function() {
      tooltipText.classList.add('open');
    });

    window.addEventListener('scroll', function() {
      if(!tooltipText.classList.contains('open')) {
        this.positionContent(tooltipText, headerHeight);
      }
    }.bind(this));
    
    window.addEventListener('click', function(e) {
      if(tooltipText.classList.contains('open')) {
        if(!(this.contains(e.target))) {
          tooltipText.classList.remove('open');
        }
      }
    }.bind(this));
  }

  positionContent(tooltipText, headerHeight) {
    const textInfo = tooltipText.getBoundingClientRect();

    if(this.getBoundingClientRect().top - headerHeight < textInfo.height) {
      tooltipText.classList.add('bottom');
    } else {
      tooltipText.classList.remove('bottom');
    }
  }
}

customElements.define('tooltip-info', TooltipInfo);

class TooltipInfoExtra extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const parentContainer = this.closest('.floating-controls-container');
    const content = this.querySelector('.tooltip-info-extra--content');
    this.parentContent = null;

    this.addEventListener('click', function() {
      this.showContent(parentContainer, content);
    }.bind(this));

    window.addEventListener('click', function(e) {
      if(this.parentContent && this.parentContent.classList.contains('open')) {
        if(!this.contains(e.target) && !this.parentContent.contains(e.target)) {
          this.parentContent.classList.remove('open');
        }
      }
    }.bind(this));
  }

  showContent(parentContainer, content) {
    const copyContent = content.cloneNode(true);
    if(!this.parentContent) {
      parentContainer.appendChild(copyContent);
      this.parentContent = copyContent;
    } else {
      this.parentContent.innerHTML = copyContent.innerHTML;
    }

    const top = this.getBoundingClientRect().top - parentContainer.getBoundingClientRect().top + this.getBoundingClientRect().height;
    this.parentContent.style.setProperty('--top-amount', `${top}px`);

    const left = this.getBoundingClientRect().left - parentContainer.getBoundingClientRect().left;
    let widthMinus = 0;
    if(left > 20) {
      this.parentContent.style.setProperty('--left-amount', "20px");
      widthMinus -= 20;
    }
    if(left < parentContainer.getBoundingClientRect().width - 20) {
      widthMinus -= 20;
    }

    this.parentContent.style.setProperty('--width-amount', `calc(100% + ${widthMinus}px)`);
    this.parentContent.style.setProperty('--point-left-amount', `${left}px`);

    this.parentContent.classList.add('open');
  }
}

customElements.define('tooltip-info-extra', TooltipInfoExtra);

class ExtraProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(window.innerWidth < 699) {
      this.style.setProperty('--width', `${window.innerWidth - 32}px`);
    }

    window.addEventListener('resize', function() {
      if(window.innerWidth < 699) {
        this.style.setProperty('--width', `${window.innerWidth - 32}px`);
      }
    }. bind(this));
    
    const extraProductButtons = this.querySelectorAll('.product-info__extra-products--button');
    const popupInfoContainer = document.querySelector('.product-info__popup-info--container');

    if(popupInfoContainer) {
      const extraAddonProductButtons = this.querySelectorAll('.product-addons__extra-products--add-button');
      const extraAddonProductRemoveButtons = this.querySelectorAll('.product-addons__extra-products--remove-button span');
      const popupOverlay = document.querySelector('.product-info__popup-info--overlay');
      const popupContainer = document.querySelector('.product-info--popup-info');
      const closeButton = popupContainer.querySelector('.product-info__popup-info--close');
      let scrollPos = 0;

      closeButton.addEventListener('click', function() {
        popupOverlay.classList.remove('open');
        document.documentElement.classList.remove('lock');
        window.scrollTo(0, scrollPos);
      });

      for(const extraAddonProductButton of extraAddonProductButtons) {
        extraAddonProductButton.addEventListener('click', function() {
          extraAddonProductButton.closest('.product-addons__extra-products--product').classList.add('checked');
        });
      }

      for(const extraAddonProductRemoveButton of extraAddonProductRemoveButtons) {
        extraAddonProductRemoveButton.addEventListener('click', function() {
          extraAddonProductRemoveButton.closest('.product-addons__extra-products--product').classList.remove('checked');
        });
      }

      for(const extraProductButton of extraProductButtons) {
        const mainContainer = extraProductButton.closest('.product-info__extra-products--item');
        const productTitle = mainContainer.querySelector('.product-info__extra-products--title span');
        const productImage = mainContainer.querySelector('.product-info__extra-products--image');
        const productPopupInfo = extraProductButton.querySelector('.product-info__extra-products--popup-info');
        
        const removeButton = mainContainer.querySelector('.product-info__extra-products--checkmark span');
        removeButton.addEventListener('click', function() {
          mainContainer.classList.remove('checked');
          mainContainer.querySelector(".product-info__extra-products--item-note").innerHTML = "";
          mainContainer.querySelector('.product-info__extra-products--image img:nth-child(2)').remove();
        });
  
        extraProductButton.addEventListener('click', function() {
          scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
        }.bind(this));
        productTitle.addEventListener('click', function() {
          if(!mainContainer.classList.contains('checked')) {
             scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
          }
        }.bind(this));
        productImage.addEventListener('click', function() {
          if(!mainContainer.classList.contains('checked')) {
             scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
          }
        }.bind(this));
      }
    }
  }

  openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay) {
    const scrollPos = window.scrollY;
    if(productPopupInfo) {
      /* Copy content to popup and open popup */
      popupInfoContainer.innerHTML = productPopupInfo.innerHTML;

      const input = popupInfoContainer.querySelector('.product-info__popup-info--textarea');
      if(input) {
        input.addEventListener('input', function() {
          input.scrollIntoView();
        });
      }
  
      const imageContainer = popupInfoContainer.querySelector('.product-info__popup-info--images');
      const images = popupInfoContainer.querySelectorAll('.product-info__popup-info--images img');
  
      if(images.length > 6) {
        imageContainer.style.maxHeight = `${images[0].getBoundingClientRect().height * 1.5 + 15}px`;
  
        window.addEventListener('resize', function() {
          imageContainer.style.maxHeight = `${images[0].getBoundingClientRect().height * 1.5 + 15}px`;
        });
      }
      
      const form = popupInfoContainer.querySelector('.product-info__popup-info--form');
  
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const formData = new FormData(form);
  
        mainContainer.querySelector('form').innerHTML = form.innerHTML;
        if(form.querySelector('[name="properties[Persoonlijk bericht]"]')) {
          mainContainer.querySelector('form [name="properties[Persoonlijk bericht]"]').value = form.querySelector('[name="properties[Persoonlijk bericht]"]').value;
        }
        
        mainContainer.classList.add('checked');
  
        const selectedImage = popupInfoContainer.querySelector('.product-info__popup-info--images img.selected');
        
        if(selectedImage) {
          const newImage = document.createElement('img');
          newImage.setAttribute('src', selectedImage.getAttribute('src').replace('"', ''));
          newImage.setAttribute('width', '900');
          newImage.setAttribute('height', '900');
          newImage.setAttribute('sizes', '100px');
          mainContainer.querySelector('.product-info__extra-products--image').appendChild(newImage);
        }
  
        if(formData.get("properties[Persoonlijk bericht]")) {
          mainContainer.querySelector('.product-info__extra-products--item-note').innerHTML = `<li>${formData.get("properties[Persoonlijk bericht]").replace('"', '').replace("\n", "<br>")}</li>`;
        }

        window.scrollTo(0, scrollPos);
        popupInfoContainer.closest('.product-info__popup-info--overlay').classList.remove('open');
        document.documentElement.classList.remove('lock');
      });
  
  
      for(const image of images) {
        image.addEventListener('click', function() {
          const prevImage =  popupInfoContainer.querySelector('.product-info__popup-info--images img.selected');
          if(prevImage) {
            prevImage.classList.remove('selected');
          }
  
          image.classList.add('selected');
          popupInfoContainer.querySelector('input[name="id"]').value = image.dataset.id;
        });
      }
      
      popupContainer.style.setProperty('--top-amount', (window.innerHeight - popupContainer.getBoundingClientRect().height) / 2 + "px");
      setTimeout(function() {
        popupOverlay.classList.add('open');
        document.documentElement.classList.add('lock');
      },100);
    }
  
    return scrollPos;
  }
}

customElements.define('extra-products', ExtraProducts);

window.addEventListener('DOMContentLoaded', function() {
  const extraProductsTemp = document.querySelector('.product-info__extra-products--temp');
  if(extraProductsTemp) {
    extraProductsTemp.addEventListener('click', function(e) {
      if(!extraProductsTemp.firstElementChild.contains(e.target)) {
        extraProductsTemp.firstElementChild.dispatchEvent(new CustomEvent("asd:add"));
      }
    });
  }

  const popupInfoOverlay = document.querySelector('.product-info__popup-info--overlay');
  popupInfoOverlay.addEventListener('click', function(e) {
    if(!popupInfoOverlay.firstElementChild.contains(e.target)) {
      popupInfoOverlay.classList.remove('open');
      document.documentElement.classList.remove('lock');
    }
  });
});

class RAODatePickerCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector('.rao-date-picker--container');
    this.blockTemp = this.container.querySelector('.rao-date-picker--block');
    this.blockTemp.remove();
    this.blacklistedDates = this.dataset.blacklistedDates.split(',');
    this.monthAmountShown = parseInt(this.dataset.monthAmountShown);
    this.monthNames = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
    this.monthLastDays = [31, 30, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    this.dayNames = ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];

    this.createCalendar();
    this.setupEvents();
  }

  setupEvents() {
    const prevButton = this.querySelector('.rao-date-picker--previous');
    const nextButton = this.querySelector('.rao-date-picker--next');
    const inputPicker = this.querySelector('.rao-date-picker--input');
    const inputText = inputPicker.querySelector('.rao-date-picker__input--text');
    const dayItems = this.querySelectorAll('.rao-date-picker--day-name:not(.no-hover)');
    const input = this.querySelector('input');
    this.selectedDay = "";
    
    let currentSlide = 0;

    prevButton.addEventListener('click', function() {
      if(currentSlide != 0) {
        currentSlide--;
        this.container.style.setProperty("--transform-amount", `-${currentSlide * 100}%`);
        if(currentSlide == 0) {
          prevButton.classList.add('disabled');
        }
        nextButton.classList.remove('disabled');
      }
    }.bind(this));

    nextButton.addEventListener('click', function() {
      if(currentSlide != this.container.querySelectorAll('.rao-date-picker--block').length - 1) {
        currentSlide++;
        this.container.style.setProperty("--transform-amount", `-${currentSlide * 100}%`);
        if(currentSlide == this.container.querySelectorAll('.rao-date-picker--block').length - 1) {
          nextButton.classList.add('disabled');
        }
        prevButton.classList.remove('disabled');
      }
    }.bind(this));

    inputPicker.addEventListener('click', function() {
      this.container.classList.toggle('open');
    }.bind(this));

    window.addEventListener('click', function(e) {
      if(this.container.classList.contains('open')) {
        if(!this.contains(e.target)) {
          this.container.classList.remove('open');
        }
      }
    }.bind(this));

    for(const dayItem of dayItems) {
      dayItem.addEventListener('click', function() {
        if(dayItem.classList.contains('selected')) {
          dayItem.classList.remove('selected');
          this.selectedDay = "";
          inputText.innerText = inputText.dataset.placeholder;
          input.value = "";
        } else {
          if(this.selectedDay != "") {
            this.selectedDay.classList.remove('selected');
          }
          
          dayItem.classList.add('selected');
          this.container.classList.remove('open');
          inputText.innerText = dayItem.dataset.date;
          this.selectedDay = dayItem;
          input.value = dayItem.dataset.date;
        }
      }.bind(this));
    }
  }

  createCalendar() {
    this.currentDate = new Date();
    this.firstAvailableDate = new Date();
    this.firstAvailableDate.setHours(24);

    if(this.currentDate.getDay() == 5) {
      if(this.currentDate.getHours() >= 16) {
        this.firstAvailableDate.setHours(72);
      }
    } else if(this.currentDate.getDay() == 6) {
      this.firstAvailableDate.setHours(48);
    } else if(this.currentDate.getDay() == 0) {
      this.firstAvailableDate.setHours(24);
    } else if(this.currentDate.getHours() >= 16) {
      this.firstAvailableDate.setHours(24);
    }

    this.firstAvailableDate = new Date(this.firstAvailableDate);
    let currentMonthIndex = this.currentDate.getMonth();
    let currentYear = this.currentDate.getFullYear();
    
    for(let i = 0; i < this.monthAmountShown; i++) {
      const blockElement = this.blockTemp.cloneNode(true);
      const monthElement = blockElement.querySelector('.rao-date-picker--month');
      const daysContainer = blockElement.querySelector('.rao-date-picker--days');
      if(currentMonthIndex > 11) {
         currentMonthIndex = 0;
        currentYear++;
      }
      monthElement.innerText = this.monthNames[currentMonthIndex];

      this.parseDayNames(daysContainer);
      this.parseWeeks(daysContainer, 1, currentYear, currentMonthIndex);

      currentMonthIndex++;
      this.container.appendChild(blockElement);
    }
  }

  parseDayNames(daysContainer) {
    const weekElement = document.createElement('div');
    weekElement.classList.add('rao-date-picker--week');
    
    for(let i = 0; i < 7; i++) {
      const dayElement = document.createElement('span');
      dayElement.classList.add('rao-date-picker--day-name');
      dayElement.classList.add('no-hover');

      dayElement.innerText = this.dayNames[i];
      weekElement.appendChild(dayElement);
    }

    daysContainer.appendChild(weekElement);
  }

  parseWeeks(daysContainer, startingDay, year, monthIndex) {
    let monthIndexTemp = monthIndex;
    let monthLastDay = 28;

    if(monthIndex != 1) {
      monthLastDay = this.monthLastDays[monthIndex];
    } else {
      if(new Date(`${year}-${monthIndex + 1}-29`).getMonth() == monthIndex) {
        monthLastDay = 29;
      } else {
        monthLastDay = 28;
      }
    }

    if(startingDay <= monthLastDay) {
      let date = new Date(`${year}-${(monthIndex + 1).toString().padStart(2, "0")}-${startingDay.toString().padStart(2, "0")}`);
      const weekElement = document.createElement('div');
      weekElement.classList.add('rao-date-picker--week');
      let counter = 0;

      for(let i = 0; i < 7; i++) {
        if(parseInt(startingDay)+i > monthLastDay) {
          break;
        }
        
        const dayElement = document.createElement('span');
        dayElement.classList.add('rao-date-picker--day-name');

        let getDay = date.getDay();
        if(getDay == 0) {
          getDay = 7;
        }
        if(i + 1 == getDay) {
          if(this.blacklistedDates.includes(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${(date.getDate()).toString().padStart(2, "0")}`)) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
          }

          if(date < this.firstAvailableDate) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
          }

          dayElement.innerText = date.getDate();
          dayElement.dataset.date = `${(date.getDate()).toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
          date.setDate(date.getDate() + 1);
          counter++;
        } else {
          dayElement.classList.add('no-hover');
        }

        weekElement.appendChild(dayElement);
      }

      daysContainer.appendChild(weekElement);
      if(parseInt(startingDay)+counter <= monthLastDay) {
        this.parseWeeks(daysContainer, parseInt(startingDay)+counter, date.getFullYear(), date.getMonth());
      }
    }
  }
}

customElements.define('rao-date-picker-cart', RAODatePickerCart);


